// extracted by mini-css-extract-plugin
export default {"dataScroller":"data-scroller_dataScroller__tImkh"};